/**
 * App-owned envelope migrations (architecture §4.2): `ENVELOPE_MIGRATIONS[n]` turns an envelope whose `schema === n`
 * into one with `schema === n + 1` (including `data.schema`). Slice migrations belong to each slice's `SliceDef`.
 *
 * Schema 1 is the first shipped schema, so the table is empty; the pipeline and its test exist so the first change is a
 * one-line addition.
 */
import type { SaveEnvelope } from '../../shared';

/** The envelope / `SaveState.schema` this build writes. */
export const CURRENT_SCHEMA = 1;

export type EnvelopeMigrations = Readonly<Record<number, (env: SaveEnvelope) => SaveEnvelope>>;

export const ENVELOPE_MIGRATIONS: EnvelopeMigrations = {};

/** Applies migrations schema → CURRENT_SCHEMA in order; throws when a step is missing. */
export function migrateEnvelope(env: SaveEnvelope, table: EnvelopeMigrations = ENVELOPE_MIGRATIONS, target = CURRENT_SCHEMA): SaveEnvelope {
  let cur = env;
  while (cur.schema < target) {
    const step = table[cur.schema];
    if (!step) throw new Error(`no envelope migration from schema ${cur.schema}`);
    const next = step(structuredClone(cur));
    if (next.schema !== cur.schema + 1) throw new Error(`envelope migration ${cur.schema} produced schema ${next.schema}`);
    cur = next;
  }
  return cur;
}
